"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhoneChecklist = void 0;

var React = __importStar(require("react"));

exports.IconPhoneChecklist = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "21",
    height: "32",
    viewBox: "0 0 21 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1908 3.61884C20.3808 7.55512 20.5083 11.9362 20.5083 16.3813C20.5083 20.5713 20.4445 24.6986 20.2545 28.3812C20.127 30.4124 18.477 32 16.4446 32H4.06363C2.03239 32 0.381106 30.4125 0.253747 28.3812C0.0637494 24.6986 0 20.5713 0 16.3813C0 11.9362 0.127499 7.5564 0.317497 3.61884C0.381247 1.5876 2.03124 0 4.0637 0H16.4447C18.4134 0 20.1272 1.58747 20.1909 3.61884H20.1908ZM19.2383 16.3813C19.2383 12.0002 19.1108 7.5564 18.9208 3.68252C18.857 2.34878 17.7783 1.27004 16.4445 1.27004H4.06353C2.79353 1.27004 1.5873 2.34878 1.5873 3.68252C1.3973 7.55512 1.2698 11.9999 1.2698 16.3813C1.2698 20.5086 1.33355 24.635 1.52355 28.3175C1.5873 29.6512 2.72978 30.73 4.06352 30.73H16.4445C17.7783 30.73 18.9208 29.6512 18.9845 28.3175C19.1745 24.635 19.2382 20.5076 19.2383 16.3813ZM10.223 27.746C10.7942 27.746 11.3017 28.1909 11.3017 28.7622C11.3017 29.3335 10.7942 29.7785 10.223 29.7785C9.71551 29.7785 9.20674 29.3335 9.20674 28.7622C9.20674 28.1909 9.71423 27.746 10.223 27.746ZM7.74683 3.2376C7.74683 3.61885 8.00059 3.8726 8.38183 3.8726H12.128C12.5093 3.8726 12.763 3.61884 12.763 3.2376C12.763 2.92009 12.5093 2.6026 12.128 2.6026H8.38183C8.00058 2.6026 7.74683 2.9201 7.74683 3.2376ZM14.6033 2.60372C14.9846 2.60372 15.2383 2.92121 15.2383 3.23872C15.2383 3.61996 14.9846 3.87372 14.6033 3.87372C14.2858 3.87372 13.9683 3.61997 13.9683 3.23872C13.9683 2.92122 14.2858 2.60372 14.6033 2.60372ZM2.57463 7.11995C2.57463 6.01538 3.47006 5.11995 4.57463 5.11995H15.9345C17.039 5.11995 17.9345 6.01538 17.9345 7.11995V24.8797C17.9345 25.9843 17.039 26.8797 15.9345 26.8797H4.57463C3.47006 26.8797 2.57463 25.9843 2.57463 24.8797V7.11995ZM5.13452 15.9998H15.3744V17.2798H5.13452V15.9998ZM15.3744 19.1998H5.13452V20.4798H15.3744V19.1998ZM5.13452 22.3998H15.3744V23.6798H5.13452V22.3998ZM11.2325 8.31992L13.5967 8.33325C14.069 8.33583 14.5212 8.53059 14.8543 8.87497C15.1874 9.21934 15.3744 9.68533 15.3744 10.1711C15.3731 10.4111 15.3258 10.6485 15.2353 10.8697C15.1448 11.091 15.0128 11.2917 14.8469 11.4605C14.6809 11.6293 14.4843 11.7628 14.2681 11.8534C14.052 11.9441 13.8206 11.99 13.5872 11.9887L12.9415 12.004V13.7599C12.7136 13.759 12.4881 13.7119 12.2779 13.6213C12.0677 13.5307 11.8769 13.3983 11.7165 13.2318C11.5561 13.0653 11.4292 12.8679 11.343 12.6509C11.2569 12.434 11.2132 12.2016 11.2144 11.9672V11.7478L11.2204 10.6058H12.9415L11.2325 8.36869V8.31992ZM8.44541 10.6001L10.2543 8.36129V8.31992H5.45434V11.4308C5.45434 12.0484 5.7071 12.6407 6.15704 13.0775C6.60698 13.5142 7.21725 13.7597 7.85364 13.7599C8.16881 13.7599 8.4809 13.6996 8.77207 13.5826C9.06325 13.4655 9.32782 13.294 9.55068 13.0777C9.77354 12.8614 9.95032 12.6047 10.0709 12.3221C10.1915 12.0395 10.2536 11.7366 10.2536 11.4308V10.6001H8.44541Z",
    fill: color
  }));
});